import React , {useEffect, useLayoutEffect} from 'react';
import './components.css';

export default () => { 
    useLayoutEffect(() => {
        document.getElementById('QrCodeSize')
                .querySelector('option[value="6"]').selected = true 

        //background selection box select to 255 for rbg
        let selectElems = document.getElementById('QRFormat')  .querySelectorAll("select")
        let selectElemIds = []
        selectElems.forEach(elem => {
            selectElemIds.push(elem.id)
        });
        selectElemIds =  selectElemIds.filter((x)=>{ return x.toLowerCase().includes("background")})

        selectElemIds.forEach(elemId => {
            document.getElementById(elemId)
            .querySelector('option[value="255"]').selected = true 
        });
    })

    let QRSize = Array.from( Array(9), (_,x) => x+2) 
    let QRColor = Array.from(Array(256), (_,x) => x )
    let qrLogo = []
    qrLogo.push( {val: 'N' , text: 'No'  , default: true })
    qrLogo.push( {val: 'logo_zh' , text: 'WVHK Chinese Logo'  , default: false })
    qrLogo.push( {val: 'logo_en' , text: 'WVHK English Logo'  , default: false })

    
    return (
        <div id='QRFormat'>
            <h2>QR Code Format:</h2>
            <div className='panel'>
                <label>QR Code Size</label>
                <select id="QrCodeSize">
                    {
                        QRSize.map((x)=> {
                        return <option value={x} >{x}
                            </option>})
                    }
                </select>
                <label>WVHK logo</label>
                <select id='QrCodeLogo' > 
                    {
                        qrLogo.map((x)=> {
                        return <option value={x.val} selected={x.default} >
                                {x.text}
                            </option>})
                    }
                </select>
                <label>Foreground Color - Red (0 -255)</label>
                <select id="QrCodeForegroundRed">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
                <label>Foreground Color - Green (0 -255)</label>
                <select id="QrCodeForegroundGreen">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
                <label>Foreground Color - Blue (0 -255)</label>
                <select id="QrCodeForegroundBlue">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
                <label>Background Color - Red (0 -255)</label>
                <select id="QrCodeBackgroundRed">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
                <label>Background Color - Green (0 -255)</label>
                <select id="QrCodeBackgroundGreen">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
                <label>Background Color - Blue (0 -255)</label>
                <select id="QrCodeBackgroundBlue">
                    {
                        QRColor.map((c)=>{
                            return <option value={c} >{c}</option>
                        })
                    }
                </select>
            </div>
        </div> 
    )
}

